// var BmPrivacyJs = require('./src')
var BmPrivacyVue = require('./src/vue')
// var BmPrivacyAngular = require('./src/angular')

// eslint-disable-next-line no-extend-native
Array.prototype.addElement = function (element) {
  var index = this.indexOf(element)
  if (index === -1) {
    this.push(element)
  }
  return this
}
// eslint-disable-next-line no-extend-native
Array.prototype.removeElement = function (element) {
  var index = this.indexOf(element)
  if (index > -1) {
    this.splice(index, 1)
  }
  return this
}

module.exports = {
  // BmPrivacyJs,
  BmPrivacyVue
  // BmPrivacyAngular
}
